import React, { useEffect, useState } from 'react';
import {
  Box,
  Heading,
  Card,
  CardHeader,
  CardBody,
  useToast,
} from '@chakra-ui/react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import axios from '../../axiosConfig';
import OrganizationSurveyForm from './OrganizationSurveyForm';

const AssignSurveyPage = () => {
  const { organizationId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();

  const isHub = location.pathname.startsWith('/hub');
  const organizationIdentifier = isHub ? 'me' : organizationId;

  const [surveys, setSurveys] = useState([]);
  const [periods, setPeriods] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const fetchSurveysAndPeriods = async () => {
      try {
        const [surveysRes, periodsRes] = await Promise.all([
          axios.get('/surveys'),
          axios.get('/survey_periods'),
        ]);
        setSurveys(surveysRes.data || []);
        setPeriods(periodsRes.data || []);
      } catch (error) {
        console.error('Error fetching surveys or periods:', error);
        toast({
          title: 'Failed to load surveys or periods',
          status: 'error',
          duration: 3000,
          isClosable: true,
        });
      }
    };

    fetchSurveysAndPeriods();
  }, [toast]);

  const handleSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      await axios.post(`/organizations/${organizationIdentifier}/organization_surveys`, data);

      toast({
        title: 'Survey assigned successfully.',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      navigate(isHub ? '/hub/surveys' : `/app/organizations/${organizationId}/surveys`);
    } catch (error) {
      console.error('Error assigning survey:', error);
      toast({
        title: error?.response?.data?.error || 'Failed to assign survey.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box mx="auto" p={6} maxW="container.md">
      <Heading as="h2" size="lg" mb={6} textAlign="center">
        Assign a Survey
      </Heading>

      <Card bg="white" shadow="md" borderRadius="lg">
        <CardHeader pb={0}>
          <Heading as="h4" size="md">
            Select Survey and Period
          </Heading>
        </CardHeader>
        <CardBody>
          <OrganizationSurveyForm
            isNew={true}
            isHub={isHub}
            onSubmit={handleSubmit}
            isSubmitting={isSubmitting}
            availablePeriods={periods}
            availableSurveys={surveys}
          />
        </CardBody>
      </Card>
    </Box>
  );
};

export default AssignSurveyPage;